import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicateContainerComponent } from './communicate-container.component';
import { DsButtonModule } from 'design-system';
import { SafeHtmlPipeModule } from 'src/app/pipes/safe-html.module';

@NgModule({
  declarations: [CommunicateContainerComponent],
  exports: [CommunicateContainerComponent],
  imports: [CommonModule, DsButtonModule, SafeHtmlPipeModule],
})
export class CommunicateContainerModule {}
